@if (isInitialized) {
  <oe-flat-widget button [title]="'Laststeuerung'" button
    [link]="'/device/' + edge.id + newNavigationUrlSegment + '/history/digitaloutputchart'" [icon]="{name:
    'power-outline',color:'normal'}">
    @for (controller of singleThresholdControllers; track controller; let first = $first) {
      <oe-flat-widget-line [name]="controller.alias" [channelAddress]="controller.id + '/CumulatedActiveTime'"
        [converter]="FORMAT_SECONDS_TO_DURATION">
      </oe-flat-widget-line>
    }
    @if (singleThresholdControllers.length > 0 && fixDigitalOutputControllers.length > 0) {
      <oe-flat-widget-horizontal-line
      ></oe-flat-widget-horizontal-line>
    }
    @for (controller of fixDigitalOutputControllers; track controller; let first = $first) {
      <oe-flat-widget-line [name]="controller.alias" [channelAddress]="controller.id + '/CumulatedActiveTime'"
        [converter]="FORMAT_SECONDS_TO_DURATION">
      </oe-flat-widget-line>
    }
  </oe-flat-widget>
}